// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*, *::before, *::after {
  box-sizing: border-box;
}

:root {
  --brand-primary: #0F172A;
  --brand-accent: #D2F800;
  --brand-accent-fg: #0F172A;

  --bg-app: #F8FAFC;
  --bg-page: #F8FAFC;
  --bg-card: #FFFFFF;
  --bg-input: #F1F5F9;

  --text-main: #1E293B;
  --text-muted: #64748B;
  --text-light: #FFFFFF;

  --border-light: #E2E8F0;
  --error: #EF4444;
  --success: #10B981;

  --radius-md: 8px;
  --radius-input: 12px;
  --radius-lg: 16px;

  --shadow-sm: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
  --shadow-card: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
  --shadow-input-focus: 0 0 0 3px rgba(15, 23, 42, 0.1);
  --shadow-lg: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);

  --transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
}

body {
  margin: 0;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
  background-color: var(--bg-app);
  color: var(--text-main);
  -webkit-font-smoothing: antialiased;
  transition: background-color 0.2s ease, color 0.2s ease;
}

::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}
::-webkit-scrollbar-track {
  background: transparent;
}
::-webkit-scrollbar-thumb {
  background: #CBD5E1;
  border-radius: 4px;
}
::-webkit-scrollbar-thumb:hover {
  background: #94A3B8;
}`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;AACxB;;AAEA;EACE,wBAAwB;EACxB,uBAAuB;EACvB,0BAA0B;;EAE1B,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;;EAEnB,oBAAoB;EACpB,qBAAqB;EACrB,qBAAqB;;EAErB,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;;EAElB,gBAAgB;EAChB,oBAAoB;EACpB,iBAAiB;;EAEjB,4CAA4C;EAC5C,oFAAoF;EACpF,qDAAqD;EACrD,oFAAoF;;EAEpF,mDAAmD;AACrD;;AAEA;EACE,SAAS;EACT,uGAAuG;EACvG,+BAA+B;EAC/B,uBAAuB;EACvB,mCAAmC;EACnC,uDAAuD;AACzD;;AAEA;EACE,UAAU;EACV,WAAW;AACb;AACA;EACE,uBAAuB;AACzB;AACA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB","sourcesContent":["*, *::before, *::after {\n  box-sizing: border-box;\n}\n\n:root {\n  --brand-primary: #0F172A;\n  --brand-accent: #D2F800;\n  --brand-accent-fg: #0F172A;\n\n  --bg-app: #F8FAFC;\n  --bg-page: #F8FAFC;\n  --bg-card: #FFFFFF;\n  --bg-input: #F1F5F9;\n\n  --text-main: #1E293B;\n  --text-muted: #64748B;\n  --text-light: #FFFFFF;\n\n  --border-light: #E2E8F0;\n  --error: #EF4444;\n  --success: #10B981;\n\n  --radius-md: 8px;\n  --radius-input: 12px;\n  --radius-lg: 16px;\n\n  --shadow-sm: 0 1px 2px 0 rgba(0, 0, 0, 0.05);\n  --shadow-card: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);\n  --shadow-input-focus: 0 0 0 3px rgba(15, 23, 42, 0.1);\n  --shadow-lg: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);\n\n  --transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\nbody {\n  margin: 0;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;\n  background-color: var(--bg-app);\n  color: var(--text-main);\n  -webkit-font-smoothing: antialiased;\n  transition: background-color 0.2s ease, color 0.2s ease;\n}\n\n::-webkit-scrollbar {\n  width: 8px;\n  height: 8px;\n}\n::-webkit-scrollbar-track {\n  background: transparent;\n}\n::-webkit-scrollbar-thumb {\n  background: #CBD5E1;\n  border-radius: 4px;\n}\n::-webkit-scrollbar-thumb:hover {\n  background: #94A3B8;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
